'use client';

import FoodQuestionCard from '@/components/sections/about/food-questions/food-question-card';
import FoodQuestionCardMobi from '@/components/sections/about/food-questions/food-question-card-mobi';
import H2 from '@/components/typography/h2';
import H3 from '@/components/typography/h3';
import P from '@/components/typography/p';
import { buildFoodQuestions } from '@/lib/food-questions';
import { Case } from '@/payload-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FoodQuestionsProps {
    cases: Case[];
}

export default function FoodQuestions({ cases }: FoodQuestionsProps) {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);

    const foodQuestionsData = buildFoodQuestions(cases);

    return (
        <>
            <div id="voedselvraagstukken" />
            {/* Desktop vi ew */}
            <div className="hidden lg:block">
                <div className="border-primary flex flex-col items-center justify-center gap-5 border-b px-5 py-30">
                    <div className="flex w-full gap-24">
                        <div className="w-5/12">
                            <div className="sticky top-[11rem] mr-4 ml-auto max-w-[612px]">
                                <H2 className="mb-8">
                                    {t('foodQuestions.title1')}

                                    <span className="abc-italic">
                                        {t('foodQuestions.title2')}
                                    </span>
                                </H2>
                                <P variant="large">{t('foodQuestions.text')}</P>
                            </div>
                        </div>
                        <div className="w-6/12">
                            <div className="mt-[-1rem] grid grid-cols-2 gap-[20px]">
                                {foodQuestionsData.map((item, index) => (
                                    <FoodQuestionCard key={index} item={item} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile view */}
            <div className="block lg:hidden">
                <div className="border-primary flex flex-col items-center justify-center gap-15 border-b px-5 py-15">
                    <div className="flex flex-col gap-6">
                        <div>
                            <H3 variant="notItalic">
                                {t('foodQuestions.title1')}
                            </H3>
                            <H3>{t('foodQuestions.title2')}</H3>
                        </div>
                        <P variant="large">{t('foodQuestions.text')}</P>
                    </div>
                    <div className="flex flex-col gap-[0.62rem]">
                        {foodQuestionsData.map((item, index) => (
                            <FoodQuestionCardMobi
                                key={index}
                                item={item}
                                index={index}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}
